import React from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const PasswordValidationIndicator = ({ validation }) => {
  if (!validation || !validation.requirements) {
    return null;
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{ marginBottom: 8, fontSize: '12px', fontWeight: 'bold', color: '#666' }}>
        Password Requirements:
      </p>
      <div style={{ fontSize: '12px' }}>
        {validation.requirements.map((requirement, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 4,
              color: requirement.valid ? '#52c41a' : '#f5222d'
            }}
          >
            {requirement.valid ? (
              <CheckCircleOutlined style={{ marginRight: 8, fontSize: '12px' }} />
            ) : (
              <CloseCircleOutlined style={{ marginRight: 8, fontSize: '12px' }} />
            )}
            <span>{requirement.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordValidationIndicator;